import React, { useEffect, useState } from "react";

// Components
import NavbarAndSidebarLayout from "~/layouts/NavbarAndSidebarLayout";
import PageHeader from "~/common/components/PageHeader";

// Pages
import List from "~/pages/investment/InvestEvalPage/list/list";
import useRequest from "~/common/hooks/useRequest";
import { API_STATE } from "~/common/constants/state";
import { useNavigate } from "react-router";

const InvestEvalPage = () => {
	const [status, setStatus] = useState([]);
	const [title, setTitle] = useState("");
	const [listData, setListData] = useState([]);
	const [listTotal, setListTotal] = useState(0);

	const [targetIdx, setTargetIdx] = useState("");

	// 화면에서 리스트와 디테일중 보여질 부분 선택 list or detail
	const [loadingPage, setLoadingPage] = useState(false);

	const searchRequest = useRequest("post", "/vc/invest/search");
	const [searchStatus, setSearchStatus] = useState(false);

	const navigate = useNavigate();

	const doSearch = (rqData, callback) => {
		//setLoadingPage(true)
		searchRequest.call(rqData, "body", callback);
	};

	const onChangeSelect = (e) => {
		setStatus(e.target.value);
	};

	const onChangeInput = (e) => {
		setTitle(e.target.value);
	};

	// setLoadingPage(false);

	useEffect(() => {
		switch (searchRequest.state) {
			case API_STATE.done:
				//setListData(searchRequest.response?.data?.list[0])

				if (searchStatus) {
					/** 스크롤 조회 **/
					setListData((prevState) => [
						...prevState,
						...searchRequest.response?.data?.list[0],
					]);
					setListTotal(listTotal + searchRequest.response?.data?.total);
				} else {
					/** 조회버튼 조회 **/
					setListData(searchRequest.response?.data?.list[0]);
					setListTotal(searchRequest.response?.data?.total);
				}

				//setLoadingPage(false);
				break;
			case API_STATE.error:
				console.log("error", searchRequest.error);
				//setLoadingPage(false);
				break;
			default:
				break;
		}
	}, [searchRequest.state, searchRequest.response, searchRequest.error]);

	const handleDetail = (idx) => {
		navigate(`/invest/evaluate/detail/${idx}`);
	};

	return (
		<NavbarAndSidebarLayout menu={["invest", "evaluate"]} type={"main"}>
			<PageHeader />
			<List
				{...{
					listData,
					setTargetIdx,
					handleDetail,
					doSearch,
					loadingPage,
					setSearchStatus,
				}}
			/>
		</NavbarAndSidebarLayout>
	);
};

export default InvestEvalPage;
